//var config = require('../axios-middlewares/config');
var crypto = require('crypto');
var now = new Date(); //当前日期
var nowDayOfWeek = now.getDay()-1; //今天本周的第几天
var nowDay = now.getDate(); //当前日
var nowMonth = now.getMonth(); //当前月
var nowYear = now.getYear(); //当前年
nowYear += (nowYear < 2000) ? 1900 : 0; //
var lastMonthDate = new Date(); //上月日期
lastMonthDate.setDate(1);
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
var lastYear = lastMonthDate.getYear();
var lastMonth = lastMonthDate.getMonth();
import _round from 'lodash/round';


class tools {

  static newGuid () {
    var guid = "";
    for (var i = 1; i <= 32; i++) {
      var n = Math.floor(Math.random() * 16.0).toString(16);
      guid += n;
      if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
        guid += "-";
    }
    return guid;
  }

  static  getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
          month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
              + " " + date.getHours() + seperator2 + date.getMinutes()
              + seperator2 + date.getSeconds();
      return currentdate;
  }


  static handleColumnDatas (it, columns,keys){
    return columns.reduce((obj, col)=>{
      if (keys.indexOf(col.name)>-1) {
        obj[col.name] = it[columns.indexOf(col)];
      }
      return obj;
    },{});
  }

  static formatData (it, columns) {
    // 根据列把数组转出{key:value}
    return columns.reduce((obj, col) => {
      obj[col.name] = it[columns.indexOf(col)];
      return obj;
    }, {});
  }


  static formatDisplay (val, format){
      // console.log('value=======format======',val,format);
      if ((format === 'Percent' || format === 'P') && parseFloat(val)){
        return Number(parseFloat(val)*100).toFixed(2)+'%';
      }
      if (format === 'M8' && parseFloat(val)){
        return parseFloat(val).toString();
      }
      if (format === 'N0' && parseInt(val)){
        return parseInt(val).toString();
      }
      if (format === 'N1' && parseFloat(val)){
        return parseFloat(val).toFixed(1);
      }
      if (format === 'N2' && parseFloat(val)){
        return parseFloat(val).toFixed(2);
      }
      if (format === 'N3' && parseFloat(val)){
        return parseFloat(val).toFixed(3);
      }
      if (format === 'N4' && parseFloat(val)){
        return parseFloat(val).toFixed(4);
      }
      if (format === 'N5' && parseFloat(val)){
        return parseFloat(val).toFixed(5);
      }
      if (format === 'N6' && parseFloat(val)){
        return parseFloat(val).toFixed(6);
      }
      if (format === 'N7' && parseFloat(val)){
        return parseFloat(val).toFixed(7);
      }
      if (format === 'N8' && parseFloat(val)){
        return parseFloat(val).toFixed(8);
      }
      return val;
    }

  static preventEvent(event) {
    if (event) {
        event.preventDefault();
        event.stopImmediatePropagation && event.stopImmediatePropagation();
        event.stopPropagation();
    }
  }

  //是否为横屏
  static isLandscape(){
     return window.screen.width > window.screen.height;
  }

  //根据小数位数 四舍五入
  static fixedNum(num,precision){
     if(typeof num !== 'number') return num;
     return _round(num,precision);
  }

  //千分符处理
  static thousandthNum(num=''){
    //return num && num.toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    var re=/\d{1,3}(?=(\d{3})+$)/g;
　　var n1=num.toString().replace(/^(-?)(\d+)((\.\d+)?)$/,function(s,s1,s2,s3){return s1+s2.replace(re,"$&,")+s3;});
// 　　var n1=num.toString().replace(/^(\d+)((\.\d+)?)$/,function(s,s1,s2){return s1.replace(re,"$&,")+s2;});
　　return n1;
  }

  //四舍五入且千分符处理
  static fixedAndThousandthNum(num,precision){
    return this.thousandthNum(this.fixedNum(num,precision));
  }

  //对数组中的元素增加百分比  name  value percent
  static caculatePercentage(arr){
    let sum = 0;
    //执行去负数操作
    return arr.filter((item,index)=>{
       if(item.value >= 0){
         sum += parseFloat(item.value);
         return true;
       }
       return false;
    }).map((item,index)=>{
       item.percentage = this.fixedNum(item.value*100/sum,2)+'%';
       return item;
    });
  }

  /**
   * 设置cookie
   */
   static setCookie(name,value){
     if(window.mutants.env.platform !== 'browser' && window.mutants.env.os == window.mutants.constant.os.android) {
       var cookieVal = name+'='+value;
       var cookieObj = {"domain":config.networkURL.targetURL,"cookie":cookieVal};
       this.enableSetAndSyncCookie([cookieObj]);
     }else{
       var Days = 30;
       var exp = new Date();
       exp.setTime(exp.getTime() + Days*24*60*60*1000);
       document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
     }
   }

   //android版本调用  写入cookie使用  param为数组类型
   static enableSetAndSyncCookie(param) {
        cordova.exec(function (res) {},
            function (res) {},
            'Cookie',
            'enableSetAndSyncCookie',
            param);
   };

  //判断是否为空
  static isNull(s) {
  	if (s==undefined || (this.trim(s) + "123" == "123")) {
  		return true;
  	}
  	return false;
  }

  //去空函数
  static trim(str) {
  	var localstr = new String(str);
  	var pattern = /^\s+|\s+$/g;
  	localstr = localstr.replace(pattern, "");
  	return localstr;
  }

  //数组包含的函数
  static arrayContains(array,element){
    if(array && this.isArray(array)){
      for (var i = 0; i < array.length; i++) {
    		if (array[i] == element) {
    			return true;
    		}
    	}
    }
  	return false;
  };

  //返回对象数组中包含相关属性值的对象索引
  static objectArrayIndexOf(objectArray,key,value){
    let i = -1;
    objectArray.forEach((item,index)=>{
      if(value == item[key]){
        i = index;
      }
    });
    return i;
  }

  //数组是否存在相关元素   如果存在  返回对应的索引值
  static arrayContainIndex(array,element){
    if(array && this.isArray(array)){
      for (var i = 0; i < array.length; i++) {
    		if (array[i] == element) {
    			return i;
    		}
    	}
    }
  	return -1;
  }

  //数组删除元素
  static arrayRemove(array,element){
      let index = this.arrayContainIndex(array,element);
      if(index > -1){
          array.splice(index,1);
      }
  }

  //数组删除索引值的元素
  static arrayRemoveByIndex(array,index){
      array.splice(index,1);
  }

  //数组模糊包含的函数
  static arrayLikeContains(array,element){
    if(array == undefined){
        return;
    }
    for (var i = 0; i < array.length; i++) {
  		if (element && element.indexOf(array[i])>-1) {
  			return true;
  		}
  	}
  	return false;
  }

  //判断是不是小数
  static isMinus(number){
    if(!this.isNull(number)){
      if(parseFloat(number) < 0){
         return true;
      }
    }
    return false;
  }

  //数组部分包含
  static arrayIndexOf(array,element){

  	for (var i = 0; i < array.length; i++) {
  		if (element.indexOf(array[i])> -1) {
  			return true;
  		}
  	}
  	return false;
  };

  //判断是否是json对象
  static isJson(obj){
  	return typeof(obj) == "object" && Object.prototype.toString.call(obj).toLowerCase() == "[object object]" && !obj.length;
  }

  //判断是否为数组
  static isArray(obj){
      return Object.prototype.toString.call(obj) == "[object Array]";
  }

  //获取历史
  static getHistory(cacheName){
    let cacheUtil = this.cache();
    let historyItemsString = cacheUtil.getLocalStorage(cacheName);
    if(historyItemsString){
        return JSON.parse(historyItemsString);
    }else{
        return [];
    }
  }

  //本地历史功能使用 写入对象为数组  插入元素写入到数组起始位置  LRU 最多保留10个元素
  static insertHistory(cacheName,historyItem){
    let cacheUtil = this.cache();
    let historyItemsString = cacheUtil.getLocalStorage(cacheName);
    let historyItems;
    if(historyItemsString){
      historyItems = JSON.parse(historyItemsString);
      let isContain = historyItems.some((item,index)=>{
        return item.ID == historyItem.ID;
      });
      if(!isContain){
        let itemLength = historyItems.unshift(historyItem);
        if(itemLength > 10){
            historyItems.pop();
        }
      }
    }else{
      historyItems = new Array();
      historyItems.push(historyItem);
    }
    cacheUtil.setLocalStorage(cacheName,JSON.stringify(historyItems));
  }

  //写入缓存
  static putCache(action,key,cacheObj){
    let cacheName = action + '_' + key;
    let cacheUtil = this.cache();
    console.log('putCache=====',cacheName,cacheObj);
    if(cacheObj){
      cacheUtil.setLocalStorage(cacheName,JSON.stringify(cacheObj));
    }
  }

  //获取缓存
  static getCache(action,key){
    console.log('getCache.key========'+key);
    let cacheName = action + '_' + key;
    let cacheUtil = this.cache();
    let cacheString = cacheUtil.getLocalStorage(cacheName);
    if(cacheString){
      try{
        return JSON.parse(cacheString);
      }catch(err){
        return undefined;
      }
    }else{
      return undefined;
    }
  }

  //清空缓存
  static clearCache(action,key){
    let cacheName = action + '_' + key;
    console.log('clearCache.key========'+cacheName);
    let cacheUtil = this.cache();
    cacheUtil.clear(cacheName);
  }

  //融合referView和ReferData
  static mergeReferViewModelAndData(VIEWMODEL){
    return VIEWMODEL.map((item,index)=>{
      let cacheData = tools.getCache('initRefer',item.uploadKey);
      if(cacheData){
        let items =  new Array();
        if(tools.isArray(cacheData)){
          cacheData.forEach((item,index)=>{
            items.push({'title':item.Name,'value':item.ID||item.Id});
          });
        }
        item.items = items;
      }else{
        item.items = [];
      }
      return item;
    });
  }

  static cache() {
    return {
      keyPrefix: 'Tplus_Report' + '_' + config.session.orgId +'_' + config.session.userId + '_',
      get: function (cacheName) {
      	cacheName = this.keyPrefix + cacheName;
      	return this[cacheName];
      },
      getLocalStorage: function(cacheName){
        cacheName = this.keyPrefix + cacheName;
        if(window.localStorage){
            return window.localStorage[cacheName];
        }else{
            return this.get(cacheName);
        }
      },
      set: function (cacheName, value) {
      	cacheName = this.keyPrefix + cacheName;
      	this[cacheName] = value;
      },
      setLocalStorage: function (cacheName, value) {
      	cacheName = this.keyPrefix + cacheName;
        if(window.localStorage){
            window.localStorage[cacheName] = value;
        }else{
            this[cacheName] = value;
        }
      },
      clear: function (cacheName) {
        cacheName = this.keyPrefix + cacheName;
        if(window.localStorage){
            window.localStorage.removeItem(cacheName);
        }else{
            this[cacheName] = undefined;
        }
      }
  }
};

  /**
   * 数字转千分符
   */
  static comdify(num)
  {
    if(isNaN(num)){
      return num;
    }
    var source = String(num).split(".");//按小数点分成2部分
    source[0] = source[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)','ig'),"$1,");//只将整数部分进行都好分割
    return source.join(".");//再将小数部分合并进来
  }

  /**
   * 格式化日期：yyyy-MM-dd
   */
  static formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth()+1;
      var myweekday = date.getDate();

      if(mymonth < 10){
          mymonth = "0" + mymonth;
      }
      if(myweekday < 10){
          myweekday = "0" + myweekday;
      }
      return (myyear+"-"+mymonth + "-" + myweekday);
  }


  /**
   * 千分符转数字
   */
  static comdifyBack(num){
    if (this.isNull(num)) {
      return '';
    }
    var x = num.split(',');
    return parseFloat(x.join(""));
  }

  //万元转换
  static toTenThousand(value,unit){

    if(value=='' || !value){
      return 0.00;
    }
    if(!unit || unit.indexOf('万')<0){
      return value;
    }
    return tools.fixedNum(Number(value/10000),2);
  }

  //获得某月的天数
  static getMonthDays(myMonth) {
      var monthStartDate = new Date(nowYear, myMonth, 1);
      var monthEndDate = new Date(nowYear, myMonth + 1, 1);
      var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
      return days;
  }
  //获得本季度的开始月份
  static getQuarterStartMonth() {
      var quarterStartMonth = 0;
      if (nowMonth < 3) {
          quarterStartMonth = 0;
      }
      if (2 < nowMonth && nowMonth < 6) {
          quarterStartMonth = 3;
      }
      if (5 < nowMonth && nowMonth < 9) {
          quarterStartMonth = 6;
      }
      if (nowMonth > 8) {
          quarterStartMonth = 9;
      }
      return quarterStartMonth;
  }
  //获得本周的开始日期
  static getWeekStartDate() {
      var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
      return this.formatDate(weekStartDate);
  }
  //获得本周的结束日期
  static getWeekEndDate() {
      var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
      return this.formatDate(weekEndDate);
  }
  //获得上周的开始日期
  static getLastWeekStartDate() {
      var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 7);
      return this.formatDate(weekStartDate);
  }
  //获得上周的结束日期
  static getLastWeekEndDate() {
      var weekEndDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 1);
      return this.formatDate(weekEndDate);
  }
  //获得本月的开始日期
  static getMonthStartDate() {
      var monthStartDate = new Date(nowYear, nowMonth, 1);
      return this.formatDate(monthStartDate);
  }
  //获得本月的结束日期
  static getMonthEndDate() {
      var monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays(nowMonth));
      return this.formatDate(monthEndDate);
  }
  //获得上月开始时间
  static getLastMonthStartDate() {
      var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
      return this.formatDate(lastMonthStartDate);
  }
  //获得上月结束时间
  static getLastMonthEndDate() {
      var lastMonthEndDate = new Date(nowYear, lastMonth, this.getMonthDays(lastMonth));
      return this.formatDate(lastMonthEndDate);
  }
  //获得本季度的开始日期
  static getQuarterStartDate() {
      var quarterStartDate = new Date(nowYear, this.getQuarterStartMonth(), 1);
      return this.formatDate(quarterStartDate);
  }
  //获得本季度的结束日期
  static getQuarterEndDate() {
      var quarterEndMonth = this.getQuarterStartMonth() + 2;
      var quarterStartDate = new Date(nowYear, quarterEndMonth,
              this.getMonthDays(quarterEndMonth));
      return this.formatDate(quarterStartDate);
  }
  //获得本季度的结束日期
  static getYearStartDate() {
      return this.formatDate(new Date(nowYear, 0, 1));
  }
  //获得本季度的结束日期
  static getYearEndDate() {
      return this.formatDate(new Date(nowYear, 11, 31));
  }

  /**
   * 根据日期获取星期几 欠款明细中使用
   */
   static getWeekday(myday){

      var strs= new Array(); //定义一数组
      strs=myday.split("-"); //字符分割
      var myDate = new Date(strs[0],parseInt(strs[1])-1,strs[2]);
      var weekDay = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      return (weekDay[myDate.getDay()]);
   }


   /**
    * 转换金额小数位数+单位
    */
   static changeToAccountNum(num,currency){
     var currencyName="";
     if(!this.isNull(num)){
       if(currency !== undefined){
         if(isJson(currency)){
            //如果是curreny对象
           currencyName = currency.Name;
         }else{
            //直接传递currencyName
            currencyName = currency;
          }
       }
       return (this.fixedAndThousandthNum(parseFloat(num),2) + currencyName);
     }else{
       return "";
     }
   }

   //检查日期是否合法
   static checkStartAndEndDate(startDate,endDate){
      if(!this.isNull(startDate)&&!this.isNull(endDate)){
          var startDateStr = startDate.split('-').join();
          var endDateStr = endDate.split('-').join();
          if(parseFloat(startDateStr)>parseFloat(endDateStr)){
              return '开始时间不能大于结束时间';
          }
      }
      return '';
   }

   //字符串加法
   static accAdd(arg1, arg2) {
    var r1, r2, m;
    try {
      r1 = arg1.toString().split(".")[1].length;
    }
    catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split(".")[1].length;
    }
    catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
  }

  //字符串减法
  static accSubtraction(arg1, arg2) {
   var r1, r2, m;
   try {
     r1 = arg1.toString().split(".")[1].length;
   }
   catch (e) {
     r1 = 0;
   }
   try {
     r2 = arg2.toString().split(".")[1].length;
   }
   catch (e) {
     r2 = 0;
   }
   m = Math.pow(10, Math.max(r1, r2));
   return (arg1 * m - arg2 * m) / m;
 }

   //公共函数
   static Map() {
       /** 存放键的数组(遍历用到) */
       this.keys = new Array();
       /** 存放数据 */
       this.data = new Object();

       /**
        * 放入一个键值对
        * @param {String} key
        * @param {Object} value
        */
       this.put = function(key, value) {
           if(this.data[key] == null){
               this.keys.push(key);
           }
           this.data[key] = value;
       };

       /**
        * 获取某键对应的值
        * @param {String} key
        * @return {Object} value
        */
       this.get = function(key) {
           return this.data[key];
       };

       /**
        * 遍历Map,执行处理函数
        *
        * @param {Function} 回调函数 function(key,value,index){..}
        */
       this.each = function(fn){
           if(typeof fn != 'function'){
               return;
           }
           var len = this.keys.length;
           for(var i=0;i<len;i++){
               var k = this.keys[i];
               fn(k,this.data[k],i);
           }
       };

       /**
        * 获取键值数组(类似Java的entrySet())
        * @return 键值对象{key,value}的数组
        */
       this.entrys = function() {
           var len = this.keys.length;
           var entrys = new Array(len);
           for (var i = 0; i < len; i++) {
               entrys[i] = {
                   key : this.keys[i],
                   value : this.data[i]
               };
           }
           return entrys;
       };

       /**
        * 判断Map是否为空
        */
       this.isEmpty = function() {
           return this.keys.length == 0;
       };

       /**
        * 获取键值对数量
        */
       this.size = function(){
           return this.keys.length;
       };

       /**
        * 重写toString
        */
       this.toString = function(){
           var s = "{";
           for(var i=0;i<this.keys.length;i++,s+=','){
               var k = this.keys[i];
               s += k+"="+this.data[k];
           }
           s+="}";
           return s;
       };
   }


   //修改日期格式样式
   static dateChange(date,s,r){
     // return date.replace('-','.');
     return date.replace(/-/ig, ".");
   }

   //获取list列表显示内容  如果labe不为空  返回label:value
   static concatLabelAndValue(label,value){
      if(this.isNull(label)){
         return value;
      }
      return label + ':' + value;
   }

   //判断是否是浮点数字
   static checkIsDecimal(num){
       var reg = /^(-?\d+)(\.\d+)?$/;
       if (reg.test(num)) {
         return true;
       }
       return false;
    }

     //获取Table的高度
     static getTableBodyHeight(subHeight){
       if(!subHeight){
         subHeight = 0;
       }
       const {os,browser,platform,constant} = mutants.env;
       let navHeight = 0;
       let DPR = parseInt(document.documentElement.getAttribute("data-dpr"));
       if (platform === 'browser') {
           navHeight = 104;//调试时使用iphone6p
       }else {
         if(constant.os.ios == os){
           //包含20的电池栏高度
           navHeight = 44+20+20;
           if(DPR==3){
             navHeight = 44+20+40;
           }
         } else {
           navHeight = 48;
         }
       }
       return (window.screen.width - navHeight - subHeight)*DPR;
     }

     static getDPR(){
       let DPR = parseInt(document.documentElement.getAttribute("data-dpr"));
       return DPR;
     }


     static getYOYGrowth(num1,num2) {
        if(num2==0){
           return '';
        }
        return this.fixedNum((num1-num2)/Math.abs(num2)*100,2);// 小数点后两位百分比
     }

     //获取万元  保留两位有效数字
     static getMillionAmount(amount){
        return tools.fixedNum(parseFloat(amount/10000),2);
     }
     //整数去除小数点
     static decimalRemoval(num){
      num.forEach((item,index)=>{
        if(item%1 == 0){
        var num = parseFloat(item)
        return num
        }
      })
     }

     //判断类型
     static type(obj) {
        var toString = Object.prototype.toString;
        var map = {
            '[object Boolean]'  : 'boolean',
            '[object Number]'   : 'number',
            '[object String]'   : 'string',
            '[object Function]' : 'function',
            '[object Array]'    : 'array',
            '[object Date]'     : 'date',
            '[object RegExp]'   : 'regExp',
            '[object Undefined]': 'undefined',
            '[object Null]'     : 'null',
            '[object Object]'   : 'object'
        };
        return map[toString.call(obj)];
      }

      //对象替换值
      static objectReplace(data,oldVal,newVal) {
          let t = this.type(data), o, i, ni;
          if(t === 'array') {
              o = [];
          }else if( t === 'object') {
              o = {};
          }else {
              if(data == oldVal){
                  return newVal;
              }
              return data;
          }
          if(t === 'array') {
              for (i = 0, ni = data.length; i < ni; i++) {
                  o.push(this.objectReplace(data[i],oldVal,newVal));
              }
              return o;
          }else if( t === 'object') {
              for( i in data) {
                  o[i] = this.objectReplace(data[i],oldVal,newVal);
              }
              return o;
          }
      }

      static cloneObj(obj){
          if(!obj){
            return obj;
          }
          let str, newobj = obj.constructor === Array ? [] : {};
          if(typeof obj !== 'object'){
              return;
          } else if(window.JSON){
              str = JSON.stringify(obj), //序列化对象
              newobj = JSON.parse(str); //还原
          } else {
              for(var i in obj){
                  newobj[i] = typeof obj[i] === 'object' ? this.cloneObj(obj[i]) : obj[i];
              }
          }
          return newobj;
        }



      //合并属性
      static combineProp(oldParam,newParam){
        if(newParam){
          for(var prop in newParam){
            if(newParam[prop]!=undefined){
                oldParam[prop] = newParam[prop];
            }
          }
        }
        return oldParam;
      }

      //clone对象
      static clone(obj){
        if(obj){
           return JSON.parse(JSON.stringify(obj));
        }
        return obj;
      }

      //将字符串转化为浮点型
      static parseFloat(numberStr){
        if(this.isNull(numberStr)){
          return 0.00;
        }
        return parseFloat(numberStr);
      }

      static startWith(all,part){
        var reg = new RegExp("^"+part);
        return reg.test(all);
      }

      static endWith(all,part){
        var reg=new RegExp(part+"$");
        return reg.test(all);
      }

      //判断对象是否是字符串
      static isString(obj){
        return Object.prototype.toString.call(obj) === "[object String]";
      }

      //先md5 在转16进制
      static md5Hex(obj){
        let str = '';
        if(this.isJson(obj)){
           str = JSON.stringify(obj);
        }else if(this.isString(obj)){
           str = obj;
        }
        let md5 = crypto.createHash('md5');
        md5.update(str);
        return md5.digest('hex');
      }

      static formatMax(txt='', max=14) {
        let ntxt = '';
        let nl = 0;
        for (let i = 0; i < txt.length; i++) {
          const t = txt[i];
          if (escape(t).indexOf('%u')<0) {
            if (nl + 1 <= max) {
              nl += 1;
              ntxt += t;
            } else {
              break;
            }
          } else {
            if (nl + 2 <= max) {
              nl += 2;
              ntxt += t;
            } else {
              break;
            }
          }
        }
        if (ntxt.length<txt.length){
          return ntxt.slice(0,ntxt.length-1)+'..';
        }else{
          return txt;
        }
      }

      static setCacheValue(cacheName, value){
        window.localStorage[cacheName] = value;
      }

      static setUserCache(cacheName, value){
        let key = 'Tplus_Warning' + '_' + cacheName +'_'+ tools.getCacheValue('session.orgId') +'_' + tools.getCacheValue('session.userId');
        this.setCacheValue(key, value);
      }

      static getCacheValue(cacheName){
        return window.localStorage[cacheName];
      }

      static getUserCache(cacheName){
        let key = 'Tplus_Warning' + '_' + cacheName +'_'+ tools.getCacheValue('session.orgId') +'_' + tools.getCacheValue('session.userId');
        return this.getCacheValue(key);
      }


      static removeCacheValue(cacheName){
        window.localStorage.removeItem(cacheName);
      }

      //获取历史
      static getHistory(cacheName){
        let historyItemsString = this.getCacheValue(cacheName);
        if(historyItemsString){
            return JSON.parse(historyItemsString);
        }else{
            return [];
        }
      }

    //本地历史功能使用 写入对象为数组  插入元素写入到数组起始位置  LRU 最多保留10个元素
    static insertHistory(cacheName,historyItem,compare){
      let historyItemsString = this.getCacheValue(cacheName);
      let historyItems;
      if(historyItemsString){
        historyItems = JSON.parse(historyItemsString);
        let isContain = historyItems.some((item,index)=>{
          if(compare){
            return compare(historyItem,item);
          }
          return item == historyItem;
        });
        if(!isContain){
          let itemLength = historyItems.unshift(historyItem);
          if(itemLength > 10){
              historyItems.pop();
          }
        }
      }else{
        historyItems = new Array();
        historyItems.push(historyItem);
      }
      this.setCacheValue(cacheName,JSON.stringify(historyItems));
    }
 }
 export default tools;
